var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "account-reset" }, [
    _c(
      "div",
      { staticClass: "context-warp" },
      [
        _c(
          "el-scrollbar",
          {
            ref: "scrollbar",
            attrs: {
              "overflow-x": "hidden",
              "wrap-class": "reset-scrollbar-wrap",
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "resetPwForm",
                staticClass: "reset-form",
                attrs: {
                  model: _vm.resetPwForm,
                  rules: _vm.resetRules,
                  "label-position": "left",
                  "content-width": "100%",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    ref: "emailFormItem",
                    attrs: { prop: "email" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "icomoon-common_user" }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: 128,
                        placeholder: _vm.$t("e-mail"),
                        tips: _vm.$t("v_email"),
                      },
                      model: {
                        value: _vm.resetPwForm.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.resetPwForm, "email", $$v)
                        },
                        expression: "resetPwForm.email",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    ref: "codeFormItem",
                    attrs: { prop: "code" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "icomoon-common_lock" }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("el-input", {
                      directives: [
                        { name: "input-limit", rawName: "v-input-limit" },
                      ],
                      ref: "verifyInput",
                      staticClass: "code-input",
                      attrs: {
                        maxlength: 6,
                        placeholder: _vm.$t("enter_hc_code"),
                        tips: _vm.$t("v_code"),
                        "data-input-type": "ten",
                      },
                      model: {
                        value: _vm.resetPwForm.code,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.resetPwForm,
                            "code",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "resetPwForm.code",
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.btnLoading,
                            expression: "btnLoading",
                          },
                        ],
                        staticClass: "code-button",
                        attrs: {
                          disabled: !_vm.getCodeStatus,
                          "max-width": 135,
                          type: "link",
                        },
                        on: { click: _vm.getVerificationCode },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "code-text ellipsis",
                            attrs: { title: _vm.$t(_vm.getCodeText) },
                          },
                          [_vm._v(_vm._s(_vm.$t(_vm.getCodeText)))]
                        ),
                        _vm.codeTimeout !== 0
                          ? _c("span", [
                              _vm._v(_vm._s("(" + _vm.codeTimeout + "s)")),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
                _c("el-input", {
                  staticStyle: { position: "fixed", bottom: "-10000px" },
                  attrs: { disabled: "" },
                }),
                _c(
                  "el-form-item",
                  {
                    ref: "passwordFormItem",
                    attrs: { prop: "password" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "icomoon-common_lock" }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c(
                      "div",
                      [
                        _c("cloud-password", {
                          attrs: {
                            "new-model": true,
                            "tips-max-width": 900,
                            placeholder: _vm.$t("input_entry_new_password"),
                            tips: _vm.$t("HPP-web_hint_password_strong"),
                            "auto-complete": "new-password",
                          },
                          model: {
                            value: _vm.resetPwForm.password,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.resetPwForm,
                                "password",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "resetPwForm.password",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "button-wrap" },
      [
        _c(
          "el-button",
          {
            staticClass: "entry-button",
            attrs: { title: _vm.$t("btn_check_email"), type: "primary" },
            on: { click: _vm.resetPassword },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("btn_check_email")) + "\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }